<script setup lang="ts">
import './MediaPreviewStatus.scss';

const props = defineProps({
    duration: {
        type: Number,
        default: 0
    },
    time: {
        type: Number,
        default: 0
    }
});

const duration = computed(() => props.duration);
const time = computed(() => props.time);
const durationTime = computed(() => new Date((props.duration - time.value) * 1000).toISOString().slice(11, 16));

const stillPercent = ref<number>(0);
if (duration.value && time.value) {
    stillPercent.value = Math.floor((time.value / duration.value) * 100);
    if (stillPercent.value >= 100) {
        stillPercent.value = 100;
    }
}
</script>

<template>
    <div class="media-preview-status-time">
        <div class="media-preview-status-time__duration">{{ durationTime }}</div>
        <div class="media-preview-status-time__percent">{{ stillPercent + '%' }}</div>
    </div>
    <div class="media-preview-status">
        <div v-if="duration && time" class="media-preview-status__status">
            <div class="media-preview-status__progress" :style="{ width: stillPercent + '%' }"></div>
        </div>
    </div>
</template>
